export default __webpack_public_path__ + "media/images/icons/gas-pump-solid-c41ebbec511c3284145550e7db41af41.svg";